import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all assetCriticalitys
export const getAssetCriticality = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/asset-criticality`);
    return response.data;
  } catch (error) {
    console.error("Error fetching assetCriticality:", error.response?.data || error);
    throw error;
  }
};

// GET a single assetCriticality
export const getAssetCriticalityById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/asset-criticality/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching assetCriticality:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new assetCriticality
export const createAssetCriticality = async (assetCriticalityData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/asset-criticality`, assetCriticalityData);
    return response.data;
  } catch (error) {
    console.error("Error creating assetCriticality:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing assetCriticality
export const updateAssetCriticality = async (id, assetCriticalityData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/asset-criticality/${id}`, assetCriticalityData);
    return response.data;
  } catch (error) {
    console.error("Error updating assetCriticality:", error.response?.data || error);
    throw error;
  }
};

// DELETE a assetCriticality
export const deleteAssetCriticality = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/asset-criticality/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting assetCriticality:", error.response?.data || error);
    throw error;
  }
};
